/** Normalized slots on the tech BG (0–1). Default anchor: bottom-center at `(nx,ny)`; `spriteAnchor: 'top'` = top-center at `(nx,ny)`. */
export const ALLIANCE_TECH_CANVAS_LAYOUT: Record<
  string,
  {
    nx: number
    ny: number
    maxW?: number
    spriteAnchor?: 'bottom' | 'top'
  }
> = {
  temple_of_aegis: { nx: 0.2, ny: 0, maxW: 275, spriteAnchor: 'top' },
  forge_of_annihilation: { nx: 0.394, ny: 0.017, maxW: 262, spriteAnchor: 'top' },
  sanctum_of_eternal_life: { nx: 0.56, ny: 0.695, maxW: 187, spriteAnchor: 'top' },
  well_of_infinite_mana: { nx: 0.802, ny: 0.03, maxW: 313, spriteAnchor: 'top' },
  celestial_granary: { nx: 0.752, ny: 0.7, maxW: 285, spriteAnchor: 'top' },
  astral_extractor: { nx: 0.143, ny: 0.678, maxW: 330, spriteAnchor: 'top' },
  ocean_of_creation: { nx: 0.615, ny: 0.315, maxW: 295, spriteAnchor: 'top' },
  vault_of_eternity: { nx: 0.33, ny: 0.322, maxW: 237, spriteAnchor: 'top' },
  citadel_of_immortality: { nx: 0.167, ny: 0.432, maxW: 313, spriteAnchor: 'top' },
  nexus_of_transcendence: { nx: 0.43, ny: 0.467, maxW: 315, spriteAnchor: 'top' },
  path_of_divine_wind: { nx: 0.843, ny: 0.43, maxW: 395, spriteAnchor: 'top' },
  chrono_sanctum: { nx: 0.362, ny: 0.68, maxW: 250, spriteAnchor: 'top' },
  law_of_preservation: { nx: 0.617, ny: 0.018, maxW: 322, spriteAnchor: 'top' },
  law_of_abundance: { nx: 0.167, ny: 0.209, maxW: 226, spriteAnchor: 'top' },
}

export function getAllianceTechCanvasSlot(
  techId: string,
  fallbackIndex: number,
): { nx: number; ny: number; maxW: number; spriteAnchor?: 'bottom' | 'top' } {
  const hit = ALLIANCE_TECH_CANVAS_LAYOUT[techId]
  if (hit) {
    return {
      nx: hit.nx,
      ny: hit.ny,
      maxW: hit.maxW ?? 200,
      spriteAnchor: hit.spriteAnchor,
    }
  }
  const COLS = 4
  const row = Math.floor(fallbackIndex / COLS)
  const col = fallbackIndex % COLS
  const nx = 0.12 + (col + 0.5) * (0.76 / COLS)
  const ny = 0.12 + (row + 0.5) * (0.76 / Math.max(1, Math.ceil(14 / COLS)))
  return { nx, ny, maxW: 180 }
}
